// Per-element styles without style="" attributes.
//
// The CSP has no 'unsafe-inline' in style-src (ANSSI VUL-003), so the browser
// refuses style="" attributes in markup and in HTML strings set through
// innerHTML. It does not restrict the CSSOM, so views and JS-built HTML put the
// declarations in data-style instead, and this applies them to element.style.
//
// A MutationObserver covers everything added after load: Turbo navigations,
// frames and streams, map popups, table cells, modals.
//
// Anything that must be hidden from the first paint (display: none) belongs in
// a class such as Tailwind's `hidden`, not here: this runs after parsing.

const apply = (el) => {
  if (el.dataset.style == null || el.dataset.styleApplied === el.dataset.style) return;
  el.style.cssText = `${el.style.cssText};${el.dataset.style}`;
  el.dataset.styleApplied = el.dataset.style;
};

const applyWithin = (root) => {
  if (root.nodeType !== Node.ELEMENT_NODE) return;
  if (root.hasAttribute("data-style")) apply(root);
  root.querySelectorAll("[data-style]").forEach(apply);
};

applyWithin(document.documentElement);

new MutationObserver((mutations) => {
  for (const m of mutations) {
    if (m.type === "attributes") apply(m.target);
    else m.addedNodes.forEach(applyWithin);
  }
}).observe(document.documentElement, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ["data-style"],
});
